import React from 'react';
import { Upload } from 'antd';
import { PrimaryButton } from 'ensightful-koala-ui';
import Papa from 'papaparse';
import styled from 'styled-components';
import uuid from 'uuid';

import { IconTextButton } from 'components/molecules/Button';
import { message } from 'shell/components';
import { generatePassword } from 'utils/helper';

const OPTIONS = {
    PRIMARY_BUTTON: 'primary-button',
    ICON_BUTTON: 'icon-button',
};

const StyledTextButton = styled(IconTextButton)`
    padding: 1em;
    margin: 0 -1em;
    & > span {
        color: ${(props) => (props.fill ? props.fill : 'unset')};
        font-weight: normal;
    }
`;

const UploadCSV = ({ onRequest, userData: users = [], option = OPTIONS.PRIMARY_BUTTON }) => {
    const handleRequest = ({ file, onProgress, onSuccess, onError }) => {
        onProgress();

        try {
            const reader = new FileReader();
            reader.onload = async () => {
                const text = reader.result;
                const isLti = process.env.REACT_APP_AUTH === 'LTI';
                const { data = [] } = Papa.parse(text, { header: true }) || {};

                // Add students into the table
                let csvVerified = true;
                if (isLti) {
                    const findErrors = data
                        .filter((item) => item.email?.length > 0)
                        .some((item) => {
                            const numOfTeams = Number(item.group);
                            if (!Number.isInteger(numOfTeams) || numOfTeams < 1 || 99 < numOfTeams) {
                                return true;
                            }
                            return false;
                        });
                    if (findErrors) return message.error('Group should be a number.');
                    const setGroupUsers = users.map((user) => {
                        const findGroup = data.find(
                            (data) => data.email === user.email || data.email === user.username
                        );
                        if (findGroup) {
                            user.group = findGroup.group;
                        }
                        user.name =
                            findGroup?.name ||
                            findGroup?.display_name ||
                            findGroup?.first_name ||
                            user.username ||
                            'No name';
                        return user;
                    });
                    const verifiedStudents = setGroupUsers.map((user) => {
                        const userData = {
                            id: user.id,
                            studentId: user.studentId,
                            username: user.username,
                            email: user.email,
                            name: user.name,
                            user_id: user.user_id,
                            password: user.username,
                            invalid: user.invalid,
                        };
                        if (user.group) userData.group = user.group;
                        return userData;
                    });
                    const newData = [].concat(verifiedStudents);
                    onRequest(newData);
                } else {
                    const newUsers = data
                        .filter((item) => item.email?.trim().length > 0)
                        .map((item) => {
                            const email = String(item.email).toLowerCase().trim();
                            const name = String(item.name).toLowerCase().trim();
                            let data = {
                                email: email || '',
                                name: name || '',
                            };
                            if (item.group) {
                                data.group = item.group;
                            }

                            // Mark the row as invalid if any field is empty
                            if (!item.email) {
                                csvVerified = false;
                                return { ...data, invalid: true };
                            }
                            return data;
                        });

                    if (!csvVerified) {
                        message.error('The uploaded CSV contains a field with empty value');
                    }

                    // Verify if there is any duplicated student IDs
                    const unique = new Set();
                    let mergedUsers = newUsers;
                    const isDuplicate = mergedUsers.some((item) => {
                        const email = String(item.email).toLowerCase();
                        return unique.size === unique.add(email).size;
                    });

                    if (isDuplicate) {
                        message.error('Same student email(s) appear more than once');

                        const onlyEmails = mergedUsers.map((user) => user.email);
                        mergedUsers = mergedUsers.filter(({ email }, index) => !onlyEmails.includes(email, index + 1));
                    }

                    // Retrieve all students with provided usernames and compare if it exists
                    // const existingUsers = await postRequest(ADMIN.LIST_USERS, {
                    //     usernames: newStudents.map((s) => s.studentId),
                    // // });
                    // const existingUsers = await adminRequests.listUsers({
                    //     usernames: newStudents.map((s) => s.studentId),
                    // });

                    // Accounts are mapped if there is an existing user record
                    const verifiedStudents = mergedUsers.map((item) => {
                        let data = {
                            id: uuid.v4(),
                            studentId: item.studentId,
                            username: item.username,
                            email: item.email,
                            name: item.name,
                            password: generatePassword(),
                            invalid: item.invalid,
                        };
                        if (item.group) {
                            data.group = item.group;
                        }
                        return data;
                    });
                    const newData = [].concat(verifiedStudents);
                    onRequest(newData);
                }

                onSuccess();
            };
            reader.readAsText(file);
        } catch (err) {
            onError();
        }
    };

    return (
        <Upload
            accept='.csv'
            style={{
                padding: 10,
                width: 'fit-content',
                height: 'fit-content',
                border: 'none',
                backgroundColor: 'none',
            }}
            customRequest={handleRequest}
            showUploadList={false}
        >
            {option === OPTIONS.PRIMARY_BUTTON ? (
                <PrimaryButton text={'Upload CSV'} active={true} style={{ minWidth: '12em' }} />
            ) : (
                <StyledTextButton kind={'cloud'} text={'Reupload CSV'} fill={'#6347FF'} active={true} />
            )}
        </Upload>
    );
};

export default UploadCSV;
